var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundBars = function SvgSoundBars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.917,
    d: "M1.333 28.333h5.334M1.333 23h5.334m-5.334-5.334h5.334m-5.334-5.333h5.334m18.666 16h5.334M25.333 23h5.334m-17.334 0h5.334m-5.334-10.667h5.334M13.333 7h5.334m-5.334-5.333h5.334m-5.334 26.666h5.334m-5.334-10.666h5.334"
  })));
};
export default SvgSoundBars;